export enum ActionTypeAI {
  Generated = 1,
  Accepted,
  Discarded,
  Regenerated
}

export enum FieldTypeAi {
  AccordancesDescription = 1,
  AccordancesCriticalIssues
}